import { useTransition } from '@react-spring/web';

export function useDropdownTransition(open: boolean) {
  return useTransition(open, {
    from: { opacity: 0, transform: 'translateY(-16px)' },
    enter: { opacity: 1, transform: 'translateY(0)' },
    leave: { opacity: 0, transform: 'translateY(-16px)' },
    config: { tension: 300, friction: 30 },
  });
} 